export var ENDPOINTS;
(function (ENDPOINTS) {
    ENDPOINTS["ROOT"] = "/";
    ENDPOINTS["MORTGAGE_ROUTE_1"] = "/mortgageroute1";
    ENDPOINTS["MORTGAGE_ROUTE_2"] = "/mortgageroute2";
    ENDPOINTS["MORTGAGE_ROUTE_3"] = "/mortgageroute3";
    ENDPOINTS["MORTGAGE_ROUTE_4"] = "/mortgageroute4";
    ENDPOINTS["MORTGAGE_ROUTE_5"] = "/mortgageroute5";
    ENDPOINTS["MORTGAGE_ROUTE_6"] = "/mortgageroute6";
    ENDPOINTS["MORTGAGE_ROUTE_7"] = "/mortgageroute7";
    ENDPOINTS["MORTGAGE_ROUTE_8"] = "/mortgageroute8";
    ENDPOINTS["MORTGAGE_ROUTE_9"] = "/mortgageroute9";
    ENDPOINTS["REFERRAL_SCOPE"] = "/referral";
    ENDPOINTS["SWITCHING_PAGE"] = "/mortgage";
    ENDPOINTS["PARTNERS_CREDIT_CARD"] = "/creditcard";
    ENDPOINTS["HEALTH_CHECK"] = "/health_check";
    ENDPOINTS["PRIVATE_PROXY_EXPORT_CASE_DATA"] = "/export/excel";
    ENDPOINTS["TAGESGELD"] = "/tagesgeld";
    ENDPOINTS["FESTGELD"] = "/festgeld";
    ENDPOINTS["KREDITKARTE"] = "/kreditkarte";
    ENDPOINTS["EXTERNAL_CREDIT_CARD_PARTNER_1"] = "https://www.zaleo.de/finanzen/vergleich/kreditkarten";
    ENDPOINTS["EXTERNAL_CREDIT_CARD_PARTNER_2"] = "/creditcard";
})(ENDPOINTS || (ENDPOINTS = {}));
